import { render, staticRenderFns } from "./planning_show.vue?vue&type=template&id=887702c2&scoped=true&"
import script from "./planning_show.vue?vue&type=script&lang=js&"
export * from "./planning_show.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "887702c2",
  null
  
)

export default component.exports